import React from "react";
import ReactSpinner from "react-bootstrap-spinner";

export function LoadingIndicator({ size = "1", color = "white", type = "border" }) {
  return <ReactSpinner type={type} color={color} size={size.toString()} />;
}
